import * as Actions from "./_ActionTypes";
const _preActionName = "CURTAIN_";

export function FullOpen(deviceId, deviceUId) {
  return {
    type: _preActionName + Actions.OPEN,
    payload: { deviceId, deviceUId },
  };
}

export function FullClose(deviceId, deviceUId) {
  return {
    type: _preActionName + Actions.CLOSE,
    payload: { deviceId, deviceUId },
  };
}

export function ChangeValueTo(
  deviceId = 0,
  deviceUId = null,
  percent,
  accessToken
) {
  let _percent = Actions.normalizePercent(percent);
  var payload = { deviceId, deviceUId, value: _percent };

  var action = {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
  return action;
}

export function ChangeValueLocallyTo(
  deviceId = 0,
  deviceUId = null,
  percent
) {
  let _percent = Actions.normalizePercent(percent);
  var payload = { deviceId, deviceUId, value: _percent };

  var action = {
    type: _preActionName + Actions.UPDATE_VALUE + "_LOCAL",
    payload,
    socket: { send: false, keepSocket: true },
  };
  return action;
}

